import React, { useState } from 'react';
import Style from './ImageGallery.module.scss';

export default function ImageGallery({ images, title }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);

    const handlePrevious = () => {
        setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    const handleTouchStart = (e) => {
        setTouchStart(e.touches[0].clientX);
    };

    const handleTouchEnd = (e) => {
        if (!touchStart) return;
        const touchEnd = e.changedTouches[0].clientX;
        const diff = touchStart - touchEnd;
        if (Math.abs(diff) > 50) {
            if (diff > 0) handleNext();
            else handlePrevious();
        }
        setTouchStart(null);
    };

    if (!images || images.length === 0) {
        return <div className={Style.noImages}>No images available</div>;
    }

    return (
        <>
            <div className={Style.gallery} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
                {images.length > 1 && (
                    <button className={`${Style.navButton} ${Style.prev}`} onClick={handlePrevious}>
                        ←
                    </button>
                )}

                <div className={Style.imageContainer}>
                    <img
                        src={images[currentIndex]}
                        alt={`${title} - ${currentIndex + 1}`}
                        className={Style.image}
                    />
                </div>

                {images.length > 1 && (
                    <button className={`${Style.navButton} ${Style.next}`} onClick={handleNext}>
                        →
                    </button>
                )}

                {images.length > 1 && (
                    <div className={Style.indicators}>
                        {images.map((_, index) => (
                            <button
                                key={index}
                                className={`${Style.indicator} ${
                                    index === currentIndex ? Style.active : ''
                                }`}
                                onClick={() => setCurrentIndex(index)}
                            />
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}
